import React, { useMemo, ReactNode } from "react";
import { tokenizer, Token } from "./whatsapp-tokenizer";

function tokensToElements(token:Token, key: number):ReactNode {
    switch(token.name){
        case "bold": return <b key={key}>{token.input.replace(/^\*|\*$/g, '')}</b>
        case "italic": return <i key={key}>{token.input.replace(/^_|_$/g, '')}</i>
        case "linetrough": return <s key={key}>{token.input.replace(/^~|~$/g, '')}</s>
        case "phone": return <a key={key} href={"tel:" + token.input.replace(/[^\d]/g, '')}>{token.input}</a>
        case "site": return <a key={key} href={token.input}>{token.input}</a>
        case "email": return <a key={key} href={`mailto:${token.input}`}>{token.input}</a>
        case "br": return <br key={key} />
        default: return token.input
    }
}

export function WhatsAppMarkdown({message}:{message:string}){
    const tokens = useMemo(() => tokenizer(message), [message]);
    const elements = useMemo(() => tokens.map(tokensToElements), [message])
    return <div className="wa-message">{elements}</div>
}